var _clipPath;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTeamIndicatorXConfirmed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 93 93",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-3126,-119)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard9",
    transform: "matrix(1,0,0,1,-0.600953,-0.47876)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3126.6,
    y: 119.479,
    width: 92.733,
    height: 92.733,
    style: {
      fill: "none"
    }
  }), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3126.6,
    y: 119.479,
    width: 92.733,
    height: 92.733
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip1)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.968497,0,0,0.968497,124.921,1206.54)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3190.86,-1054.32C3197.3,-1047.88 3197.3,-1037.43 3190.86,-1031C3184.43,-1024.56 3173.98,-1024.56 3167.54,-1031C3167.54,-1031 3104.76,-1093.78 3104.76,-1093.78C3098.33,-1100.21 3098.33,-1110.66 3104.76,-1117.1C3111.2,-1123.53 3121.65,-1123.53 3128.08,-1117.1L3190.86,-1054.32Z",
    style: {
      fill: "rgb(249,98,99)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(5.93034e-17,-0.968497,0.968497,5.93034e-17,4213.78,3214.97)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3190.86,-1054.32C3197.3,-1047.88 3197.3,-1037.43 3190.86,-1031C3184.43,-1024.56 3173.98,-1024.56 3167.54,-1031C3167.54,-1031 3104.76,-1093.78 3104.76,-1093.78C3098.33,-1100.21 3098.33,-1110.66 3104.76,-1117.1C3111.2,-1123.53 3121.65,-1123.53 3128.08,-1117.1L3190.86,-1054.32Z",
    style: {
      fill: "rgb(249,98,99)"
    }
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeamIndicatorXConfirmed);
export default __webpack_public_path__ + "static/media/team_indicator_x_confirmed.bd62764a4f0fd2a4f41e8ef391595a16.svg";
export { ForwardRef as ReactComponent };